const typeDocumentAdministratifsLabels = {
  afgsu: 'AFGSU',
  asf: 'ASF',
  attestation_400m: 'Attestation 400m',
  attestation_assurance_maladie_datee_de_moins_de_3_mois: 'Attestation assurance maladie (datée de moins de 3 mois)',
  attestation_assurance_scolaire_bts: 'Attestation assurance scolaire - BTS',
  attestation_campus: 'Attestation Campus',
  attestation_completude_dossier_specifique_ffe: 'Attestation de complétude du dossier spécifique FFE',
  attestation_cpam: 'Attestation CPAM',
  attestation_employeur: 'Attestation employeur',
  attestation_entree_formation: 'Attestation d\'entrée en formation',
  attestation_epmsp: 'Attestation EPMSP',
  attestation_fin_formation: 'Attestation de fin de formation',
  attestation_inscription_formation: 'Attestation d\'inscription en formation',
  attestation_prise_connaissance: 'Attestation de prise de connaissance',
  attestation_recensement: 'Attestation de recensement',
  attestation_responsabilite_civile: 'Attestation de responsabilité civile',
  attestation_rqth: 'Attestation RQTH',
  attestation_rugby: 'Attestation Rugby',
  attestation_securite_sociale: 'Attestation de sécurité sociale',
  attestations_tep: 'Attestations TEP',
  autorisation_parentales: 'Autorisation parentale',
  autorisation_reproduction: 'Autorisation de reproduction',
  autorisation_travail: 'Autorisation de travail',
  avis_situation_france_travail_moins_3_mois: 'Avis situation France Travail (- 3 mois)',
  avis_situation_ft: 'Avis de situation FT',
  bnssa: 'BNSSA',
  bti_entretiens: 'BTI / Entretiens',
  bulletins_salaire: 'Bulletins de salaire',
  bulletins_salaire_sur_24_mois: 'Bulletins de salaire (sur 24 mois)',
  carte_professionnelle: 'Carte professionnelle',
  carte_sejour: 'Carte de séjour',
  carte_vitale: 'Carte vitale',
  cerfa_contrat_formation: 'Cerfa ou contrat de formation',
  certificat_jdc: 'Certificat journée de défense citoyenne',
  certificat_medical: 'Certificat médical',
  cheque: 'Chèque',
  cni: 'Carte d\'identité',
  cni_europe: 'Carte d\'identité européenne',
  consentement_rgpd: 'Consentement RGPD',
  contrat_formation: 'Contrat de formation',
  convention_formation: 'Convention de formation',
  convention_pret_chromebook: 'Convention de prêt de chromebook',
  convention_stage: 'Convention de stage',
  copie_du_livret_de_famille: 'Copie du livret de famille',
  courrier_admission: 'Courrier admission',
  cv: 'CV',
  dernier_avis_imposition_pour_les_personnes_ayant_des_enfants_a_charge: 'Dernier avis d\'imposition (personnes ayant des enfants à charge)',
  documents_diplomes: 'Diplômes',
  dossier_inscription: 'Dossier d\'inscription',
  droit_image: 'Droit à l\'image',
  droit_image_cfa: 'Droit à l\'image CFA',
  droit_image_hors_cfa: 'Droit à l\'image hors CFA',
  evaluations_formatives: 'Évaluations formatives',
  extrait_casier_judiciaire: 'Extrait casier judiciaire',
  fiche_liaison: 'Fiche de liaison',
  fiche_mission: 'Fiche mission',
  fiche_prescription: 'Fiche de prescription',
  fiche_signalitique: 'Fiche signalétique',
  grille_certification: 'Grille de certification signée',
  journee_appel_bts: 'Journée d\'appel - BTS',
  justificatif_rsa_pour_les_personnes_beneficiaires: 'Justificatif RSA (pour personnes bénéficiaires)',
  justificatifs_d_indemnites_journalieres_en_cas_d_arret_de_travail: 'Justificatifs d\'indemnités journalières (en cas d\'arrêt de travail)',
  licence_ffe: 'Licence FFE',
  notification_rejet_are_france_travail_moins_3_mois: 'Notification rejet ARE France Travail (- 3 mois)',
  notification_rqth_en_cours_de_validite: 'Notification RQTH (en cours de validité)',
  paiement_cvec: 'Paiement CVEC',
  passeport: 'Passeport',
  positionnement: 'Fiche de positionnement',
  psc1: 'PSC',
  pse1: 'PSE1',
  pse2: 'PSE2',
  reglement_interieur: 'Règlement intérieur',
  releve_notes: 'Relevé de notes',
  remu_region: 'Rémunération Région',
  rib: 'RIB/IBAN',
  rs1_cerfa_remu: 'RS1 (CERFA pour rému)',
  sst: 'SST',
  titre_sejour_en_cours_de_validite: 'Titre de séjour en cours de validité',
  validite_france_travail: 'Validité France Travail',
  visites_structure: 'Visites en structure'
}

// Échelles de notation.
// evaluationScale : évaluations pédagogiques.
// positionnementScale : tests de positionnement (si absent, même échelle que les évaluations).
// Le non diplômant reste en paliers 1 à 4.
const evaluationScales = {
  acquis: [
    { score: 3, label: 'Acquis' },
    { score: 2, label: 'En cours' },
    { score: 1, label: 'Non acquis' },
    { score: 0, label: 'Non évalué' }
  ],
  palier: [
    { score: 4, label: 'Palier 4' },
    { score: 3, label: 'Palier 3' },
    { score: 2, label: 'Palier 2' },
    { score: 1, label: 'Palier 1' },
    { score: 0, label: 'Non évalué' }
  ],
  apfa: [
    { score: 1, label: 'Émergent' },
    { score: 2, label: 'Perfectible' },
    { score: 3, label: 'Maîtrisé' },
    { score: 0, label: 'Non évalué' }
  ]
}

const paramCfas = {
  default: {
    id: 1,
    userLogged: ['cfa'], // l'entité loggé est-elle un cfa ou une antenne ? (["cfa"]/["antenne"]/["cfa","antenne"])
    cfa: {
      id: null // identifiant du cfa dans la table cfa (ici null pour les paramètres par default)
    },
    testOnly: false, // pour les clients tests (true/false)
    activities: ['autre'], // secteurs d'activité du cfa
    denominations: {
      menuGestion: 'CFA DEMO',
      menuFormation: 'Pédagogie',
      antenneField: 'Antenne',
      codeAnalytiqueField: 'Code analytique', // dans stagiaire/facturation
      antennelModuleName: 'Centre de formation',
      antenneOrDispositif: 'Antenne'
    },
    menu: {
      formation: [], // droits d'affichage des sous-modules
      facturation: [],
      postformation: [],
      gestion: [],
      taxes: [],
      candidature: []
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: [''],
      typeDocumentAdministratifs: [
        'attestation_securite_sociale',
        'attestation_responsabilite_civile',
        'carte_sejour',
        'certificat_jdc',
        'certificat_medical',
        'consentement_rgpd',
        'cni',
        'cni_europe',
        'extrait_casier_judiciaire',
        'fiche_liaison',
        'passeport',
        'rib',
        'validite_france_travail',

        'psc1',
        'pse1',
        'documents_diplomes',
        'dossier_inscription',
        'bnssa',
        'attestations_tep',
        'carte_professionnelle',
        'cheque',
        'fiche_signalitique',
        'cv',
        'licence_ffe',
        'attestation_completude_dossier_specifique_ffe',
        'attestation_campus',
        'cerfa_contrat_formation',
        'convention_formation',
        'attestation_entree_formation',
        'droit_image_cfa',
        'droit_image_hors_cfa',
        'reglement_interieur',
        'courrier_admission',
        'attestation_securite_sociale',
        'attestation_securite_sociale',
        'attestation_securite_sociale',
        'attestation_securite_sociale'
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'attestation_epmsp',
        'attestation_reussite',
        'attestation_reussite_partielle',
        'attestation_sortie',
        'bti_entretiens',
        'emargement_1er_equipement',
        'equivalence',
        'evaluations_formatives',
        'pif',
        'positionnement',
        'fiche_mission',
        'fiche_poste',
        'grille_certification',
        // 'grille_positionnement',
        'grille_selection',
        // 'grille_tep',
        'test_exigences',
        'visites_structure'
      ]
    },
    entretien: {
      interviewsType: [
        'entretiens_entree',
        'entretien_mi_parcours',
        'entretien_fin_parcours',
        'suivi_apprentissage',
        'entretien_confidentiel',
        'autre'
      ]
    },
    pedagogie: {
      filtres: [''],
      evaluationScale: evaluationScales.acquis
    },
    accessRight: {
      hasSectors: false, // l'antenne ou le cfa voit t'il les secteurs de formation (true/false)
      hasAdministrativeBranch: false, // l'antenne ou le cfa voit t'il l'antenne administrative (true/false)
      hasSessions: false, // l'antenne ou le cfa voit'il les sessions (dans sessions /groupes) (true/false)
      hasGroups: false, // l'antenne ou le cfa voit'il les groupes (dans sessions /groupes) (true/false)
      typeDiplome: true, // l'antenne ou le cfa voit'il le champs type de diplôme (dans diplome) (true/false)
      hasActionsRatingStars: false, // l'antenne ou le cfa voit'il les évaluations des actions pédagogiques en rating (étoiles)
      hasRepositoriesRatingStars: false, // l'antenne ou le cfa voit'il les évaluations des actions pédagogiques en rating (étoiles)
      canChangeAntenneInSwitchStudent: false, // l'antenne ou le cfa voit il le champs antennes (dans basculer stagiaire) (true/false)
      hasSigVille: true, // bouton de vérification QPV SIG Ville à côté de l'adresse
      // Annuaire entreprise global : toutes les entreprises sur le siège, visibles par tout le CFA.
      // false = le superviseur doit choisir un dispositif de formation à l'ajout.
      annuaireEntrepriseGlobal: false,
      gedFolders: []
    },
    conventions: {
      haveFeeTypeShortList: false
    },
    // champ json en bdd - ordre des champs dans "formation" du formulaire stagiaire (ou candidature) - ici par blocs
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0', //1
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  // Toutes les antennes de FUTUROSUD
  // antennes: {
  //   id: 2,
  //   userLogged: ['antenne'],
  //   cfa: {
  //     id: 1
  //   },
  //   testOnly: false,
  //   activities: ['sport'],
  //   denominations: {
  //     menuGestion: 'Antenne UFA',
  //     menuFormation: 'FORMATION',
  //     antenneField: 'Antenne ',
  //     codeAnalytiqueField: 'Code analytique',
  //     antennelModuleName: 'Centre de formation',
  //     antenneOrDispositif: 'Antenne'
  //   },
  //   menu: {
  //     formation: [
  //       'francecompetences',
  //       'referentiels',
  //       'actions',
  //       'sequences',
  //       'pif',
  //       'evaluations',
  //       'evaluations_cps',
  //       'tests'
  //     ],
  //     facturation: [],
  //     postformation: ['suivis'],
  //     gestion: [
  //       'antenne',
  //       'tableaudebord',
  //       'statistiques',
  //       'gedcollaborative',
  //       'modeles',
  //       'gestionutilisateurs'
  //     ],
  //     taxes: [],
  //     candidature: []
  //   },
  //   accessRight: {
  //     hasSectors: true,
  //     hasAdministrativeBranch: true,
  //     hasSessions: true,
  //     hasGroups: true,
  //     typeDiplome: true,
  //     hasActionsRatingStars: false,
  //     hasRepositoriesRatingStars: false,
  //     canChangeAntenneInSwitchStudent: true,
  //     gedFolders: ['cfa', 'antenne', 'espace_perso', 'pdp'],
  //     canSeeConventionNumberOnFacturation: true
  //   },
  //   pedagogie: {
  //     filtres: ['']
  //   },
  //   conventions: {
  //     haveFeeTypeShortList: false
  //   },
  //   facturation: {
  //     typeFactureDetails: [
  //       'pack_informatique',
  //       'pack_materiel',
  //       'pack_informatique_1er_acompte',
  //       'pack_informatique_2eme_acompte',
  //       'pack_informatique_3eme_acompte',
  //       'pack_informatique_4eme_acompte',
  //       'pack_informatique_5eme_acompte',
  //       'pack_informatique_6eme_acompte'
  //     ]
  //   },
  //   stagiaire: {
  //     filtres: [''],
  //     typeDocumentPedagogiques: [
  //       'attestations_tep',
  //       'attestation_stagiaire_formation',
  //       'reglement_interieur',
  //       'droit_image',
  //       'consentement_rgpd',

  //       'contrat_apprentissage',
  //       'cerfa_contrat_formation',
  //       'contrat_formation',
  //       'convention_stage',
  //       'attestation_epmsp',
  //       'attestation_fin_formation',
  //       'bilan_fin_parcours'
  //     ],
  //     typeDocumentAdministratifs: [
  //       'autorisation_parentales',
  //       'dossier_inscription',
  //       'fiche_signalitique',
  //       'certificat_medical',
  //       'psc1',
  //       'afgsu',
  //       'sst',
  //       'attestation_recensement',
  //       'certificat_jdc',
  //       'attestation_securite_sociale',
  //       'attestation_responsabilite_civile',
  //       'cni',
  //       'cni_europe',
  //       'passeport',
  //       'carte_sejour',
  //       'fiche_liaison',
  //       'fiche_prescription',
  //       'validite_france_travail',
  //       'documents_diplomes',
  //       'cv',
  //       'rib',
  //       'remu_region',
  //       'asf'
  //     ]
  //   },
  //   entretien: {
  //     interviewsType: [
  //       'entretiens_entree',
  //       'entretien_mi_parcours',
  //       'entretien_fin_parcours',
  //       'suivi_apprentissage',
  //       'entretien_confidentiel',
  //       'autre'
  //     ]
  //   },
  //   // champ json en bdd
  //   orderFieldsTrainingForm: {
  //     type_cursus: 'order-0',
  //     antenne_convention: 'order-1',
  //     status: 'order-2',
  //     type_status_autre_details: 'order-3',
  //     antenne: 'order-4',
  //     antenne_secteur: 'order-5',
  //     diplome: 'order-6',
  //     diplome_session: 'order-7',
  //     module: 'order-8',
  //     antenne_groupe_session: 'order-7',
  //     dt_date_entree: 'order-8',
  //     date_entree_prevue: 'order-8',
  //     date_sortie_prevue: 'order-9',
  //     date_selection_trials: 'order-10',
  //     date_selection_requirement: 'order-11',
  //     date_positioning_start: 'order-12',
  //     date_positioning_end: 'order-12',
  //     dt_date_first_contact: 'order-100',
  //     funding: 'order-101',
  //     funding_details: 'order-102',
  //     formation_hours: 'order-103',
  //     company_hours: 'order-104',
  //     entreprise_tuteur_title: 'order-200',
  //     desired_entreprise: '201',
  //     desired_tutor: 'order-202',
  //     desired_tutor_lastname: 'order-203',
  //     desired_tutor_firstname: 'order-204',
  //     btn_choose_another_tuteur: 'order-205',
  //     pole_emploi_title: 'order-300',
  //     pole_emploie_id: 'order-301',
  //     pole_emploie_since: 'order-302',
  //     pole_emploie_agency: 'order-303',
  //     pole_emploie_advisor: 'order-304',
  //     pole_emploie_advisor_phone: 'order-305',
  //     formationCustomFields: 'order-306'
  //   }
  // },
  // futurosud: {
  //   id: 3,
  //   userLogged: ['cfa'],
  //   cfa: {
  //     id: 1
  //   },
  //   testOnly: false,
  //   activities: ['sport'],
  //   denominations: {
  //     menuGestion: 'CFA FUTUROSUD',
  //     menuFormation: 'FORMATION',
  //     antenneField: 'Antenne de déroulement ',
  //     codeAnalytiqueField: 'Code analytique',
  //     antennelModuleName: 'Centre de formation',
  //     antenneOrDispositif: 'Antenne'
  //   },
  //   menu: {
  //     formation: [
  //       'francecompetences',
  //       'referentiels',
  //       'actions',
  //       'sequences',
  //       'pif',
  //       'evaluations',
  //       'evaluations_cps',
  //       'tests'
  //     ],
  //     facturation: ['aidesmobilises', 'factures'],
  //     postformation: ['enquetesatisfaction', 'questionnaireinsertion'],
  //     // TODO: enlever 'referentiels'
  //     gestion: [
  //       'parametres',
  //       'referentiels',
  //       'tableaudebord',
  //       'antenne',
  //       'diplomes',
  //       'statistiques',
  //       'gedcollaborative',
  //       'modeles',
  //       'gestionutilisateurs'
  //     ],
  //     taxes: ['all_taxes'],
  //     candidature: []
  //   },
  //   accessRight: {
  //     hasSectors: true,
  //     hasAdministrativeBranch: false,
  //     hasSessions: false,
  //     hasGroups: false,
  //     typeDiplome: true,
  //     hasActionsRatingStars: false,
  //     hasRepositoriesRatingStars: false,
  //     canChangeAntenneInSwitchStudent: true,
  //     gedFolders: ['cfa', 'siège', 'espace_perso', 'pdp'],
  //     canSeeConventionNumberOnFacturation: true
  //   },
  //   conventions: {
  //     haveFeeTypeShortList: false
  //   },
  //   facturation: {
  //     typeFactureDetails: [
  //       'pack_informatique',
  //       'pack_materiel',
  //       'pack_informatique_1er_acompte',
  //       'pack_informatique_2eme_acompte',
  //       'pack_informatique_3eme_acompte',
  //       'pack_informatique_4eme_acompte',
  //       'pack_informatique_5eme_acompte',
  //       'pack_informatique_6eme_acompte'
  //     ]
  //   },
  //   stagiaire: {
  //     filtres: ['antennes'],
  //     typeDocumentAdministratifs: [
  //       'autorisation_parentales',
  //       'dossier_inscription',
  //       'fiche_signalitique',
  //       'certificat_medical',
  //       'psc1',
  //       'afgsu',
  //       'sst',
  //       'attestation_recensement',
  //       'certificat_jdc',
  //       'attestation_securite_sociale',
  //       'attestation_responsabilite_civile',
  //       'cni',
  //       'cni_europe',
  //       'passeport',
  //       'carte_sejour',
  //       'fiche_liaison',
  //       'fiche_prescription',
  //       'validite_france_travail',
  //       'documents_diplomes',
  //       'cv',
  //       'rib',
  //       'remu_region',
  //       'asf'
  //     ],
  //     typeDocumentPedagogiques: [
  //       'attestations_tep',
  //       'attestation_stagiaire_formation',
  //       'reglement_interieur',
  //       'droit_image',
  //       'consentement_rgpd',

  //       'contrat_apprentissage',
  //       'cerfa_contrat_formation',
  //       'contrat_formation',
  //       'convention_stage',
  //       'attestation_epmsp',
  //       'attestation_fin_formation',
  //       'bilan_fin_parcours'
  //     ]
  //   },
  //   entretien: {
  //     interviewsType: [
  //       'entretiens_entree',
  //       'entretien_mi_parcours',
  //       'entretien_fin_parcours',
  //       'suivi_apprentissage',
  //       'entretien_confidentiel',
  //       'autre'
  //     ]
  //   },
  //   // champ json en bdd
  //   orderFieldsTrainingForm: {
  //     type_cursus: 'order-3',
  //     status: 'order-4',
  //     type_status_autre_details: 'order-5',
  //     antenne: 'order-0',
  //     antenne_secteur: 'order-2',
  //     antenne_convention: 'order-2',
  //     type_action: 'order-6',
  //     diplome: 'order-6',
  //     module: 'order-6',
  //     diplome_session: 'order-7',
  //     action_session: 'order-7',
  //     antenne_groupe_session: 'order-7',
  //     dt_date_entree: 'order-8',
  //     date_entree_prevue: 'order-8',
  //     date_sortie_prevue: 'order-9',
  //     date_selection_trials: 'order-10',
  //     date_selection_requirement: 'order-11',
  //     date_positioning_start: 'order-12',
  //     date_positioning_end: 'order-12',
  //     dt_date_first_contact: 'order-100',
  //     funding: 'order-101',
  //     funding_details: 'order-102',
  //     formation_hours: 'order-103',
  //     company_hours: 'order-104',
  //     entreprise_tuteur_title: 'order-200',
  //     desired_entreprise: '201',
  //     desired_tutor: 'order-202',
  //     desired_tutor_lastname: 'order-203',
  //     desired_tutor_firstname: 'order-204',
  //     btn_choose_another_tuteur: 'order-205',
  //     pole_emploi_title: 'order-300',
  //     pole_emploie_id: 'order-301',
  //     pole_emploie_since: 'order-302',
  //     pole_emploie_agency: 'order-303',
  //     pole_emploie_advisor: 'order-304',
  //     pole_emploie_advisor_phone: 'order-305',
  //     formationCustomFields: 'order-306'
  //   }
  // },
  apfa: {
    id: 3,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 1
    },
    testOnly: false,
    activities: ['sport'],
    denominations: {
      menuGestion: 'APFA',
      menuFormation: 'Pédagogie',
      antenneField: 'Dispositif de déroulement ',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Centre de formation',
      antenneOrDispositif: 'Dispositif'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: ['enquetesatisfaction', 'questionnaireinsertion'],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: ['all_taxes'],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: false,
      hasGroups: false,
      typeDiplome: true,
      hasActionsRatingStars: false,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: true,
      gedFolders: ['cfa', 'siège', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true
    },
    conventions: {
      haveFeeTypeShortList: false
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'autorisation_parentales',
        'dossier_inscription',
        'fiche_signalitique',
        'certificat_medical',
        'psc1',
        'afgsu',
        'sst',
        'attestation_recensement',
        'certificat_jdc',
        'attestation_securite_sociale',
        'attestation_responsabilite_civile',
        'cni',
        'cni_europe',
        'passeport',
        'carte_sejour',
        'fiche_liaison',
        'fiche_prescription',
        'validite_france_travail',
        'documents_diplomes',
        'cv',
        'rib',
        'remu_region',
        'asf'
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'attestations_tep',
        'attestation_stagiaire_formation',
        'reglement_interieur',
        'droit_image',
        'consentement_rgpd',

        'contrat_apprentissage',
        'cerfa_contrat_formation',
        'contrat_formation',
        'convention_stage',
        'attestation_epmsp',
        'attestation_fin_formation',
        'bilan_fin_parcours'
      ]
    },
    entretien: {
      interviewsType: [
        'entretiens_entree',
        'entretien_mi_parcours',
        'entretien_fin_parcours',
        'suivi_apprentissage',
        'entretien_confidentiel',
        'autre'
      ]
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.acquis,
      positionnementScale: evaluationScales.apfa
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  guyhoquet: {
    id: 4,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 13
    },
    testOnly: false,
    activities: ['immobilier'],
    denominations: {
      menuGestion: 'GUY HOQUET',
      menuFormation: 'Pédagogie',
      antenneField: 'Campus souhaité',
      codeAnalytiqueField: 'Code agence',
      antennelModuleName: 'Centre de formation',
      antenneOrDispositif: 'Antenne'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: ['enquetesatisfaction', 'questionnaireinsertion'],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: [],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: false,
      hasGroups: true,
      typeDiplome: false,
      hasActionsRatingStars: false,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['cfa', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: false,
      hasSigVille: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte',
        'solde-avoir'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_securite_sociale',
        'attestation_responsabilite_civile',
        'carte_sejour',
        'certificat_jdc',
        'certificat_medical',
        'consentement_rgpd',
        'cni',
        'cni_europe',
        'extrait_casier_judiciaire',
        'fiche_liaison',
        'passeport',
        'rib',
        'validite_france_travail',

        'psc1',
        'pse1',
        'documents_diplomes',
        'dossier_inscription',
        'bnssa',
        'attestations_tep',
        'carte_professionnelle',
        'cheque',
        'fiche_signalitique',
        'cv',
        'licence_ffe',
        'attestation_completude_dossier_specifique_ffe',
        'attestation_campus',
        'cerfa_contrat_formation',
        'convention_formation',
        'attestation_entree_formation',
        'droit_image_cfa',
        'droit_image_hors_cfa',
        'reglement_interieur',
        'courrier_admission',
        'attestation_securite_sociale',
        'attestation_securite_sociale',
        'attestation_securite_sociale',
        'attestation_securite_sociale'
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'attestation_assiduite_formation',
        'attestation_fin_formation',
        'bulletin_1er_semestre_1_annee',
        'bulletin_2eme_semestre_1_annee',
        'bulletin_1er_semestre_2_annee',
        'bulletin_2eme_semestre_2_annee',
        'certificat_scolarite_1_annee',
        'certificat_scolarite_2_annee',
        'certificat_realisation_1/4',
        'certificat_realisation_2/4',
        //'certificat_realisation_3/4',
        //'certificat_realisation_4/4',
        'dossier_candidature',
        'dossier_cpap',
        'positionnement',
        'premier_bts_blanc',
        'questionnaire_peda_1_1_annee',
        'questionnaire_peda_2_1_annee',
        'questionnaire_peda_1_2_annee',
        'questionnaire_peda_2_2_annee',
        'releve_de_notes_bts',
        'second_bts_blanc',
        'suivi_entreprise_1',
        'suivi_entreprise_2'
      ]
    },
    entretien: {
      interviewsType: [
        'entretiens_entree',
        'entretien_mi_parcours',
        'entretien_fin_parcours',
        'referent_ecole',
        'suivi_apprentissage',
        'entretien_confidentiel',
        'autre'
      ]
    },
    pedagogie: {
      filtres: [''],
      evaluationScale: evaluationScales.acquis
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-0',
      status: 'order-0',
      type_status_autre_details: 'order-0',
      antenne: 'order-1',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-3',
      diplome: 'order-3',
      module: 'order-3',
      diplome_session: 'order-4',
      action_session: 'order-4',
      antenne_groupe_session: 'order-4',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  afept: {
    id: 6,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 20
    },
    testOnly: true,
    activities: ['multi'],
    denominations: {
      menuGestion: 'AFEPT',
      menuFormation: 'Pédagogie',
      antenneField: 'Dispositif de formation',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Dispositifs de formation',
      antenneOrDispositif: 'Dispositif'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'suivis',
        'enquetesatisfaction',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: [],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: true,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['siège', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_assurance_maladie_datee_de_moins_de_3_mois',
        'attestation_employeur',
        'avis_situation_france_travail_moins_3_mois',
        'bulletins_salaire_sur_24_mois',
        'cni',
        'copie_du_livret_de_famille',
        'dernier_avis_imposition_pour_les_personnes_ayant_des_enfants_a_charge',
        'droit_image',
        'justificatifs_d_indemnites_journalieres_en_cas_d_arret_de_travail',
        'justificatif_rsa_pour_les_personnes_beneficiaires',
        'notification_rqth_en_cours_de_validite',
        'passeport',
        'rib',
        'titre_sejour_en_cours_de_validite',
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'non_renseigne',
        'fiche_de_prescription_afept',
        'fiche_de_renseignement_afept',
        'planning_de_formation_afept',
        'reglement_interieur_afept',
        'charte_informatique_afept',
        'consentement_rgpd_afept',
        'Droit_a_l_image_afept',
        'attestation_de_prise_de_connaissance_afept',
        'attestation_entree_formation_afept',
        'pif_afept',
        'contrat_pedagogique_afept',
        'livret_suivi_individuel_parcours_afept',
        'bilan_intermediaire_afept',
        'bilan_final_afept',
        'attestation_competences_acquises_afept',
        'attestation_fin_formation_afept',
        'questionnaire_de_satisfaction_afept'
      ]
    },
    entretien: {
      interviewsType: [
        'accompagnement_sante_social',
        'contractualisation_engagement',
        'entretien_accueil',
        'entretien_referent_handicap',
        'entretien_regulation',
        'entretien_suivi_pedagogique',
        'entretien_suivi_projet_professionnel',
        'securisation_parcours',
        'entretien_confidentiel',
        'entretien_remediation',
        'administratif'
      ]
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.palier
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  usap: {
    id: 7,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 30
    },
    testOnly: true,
    activities: ['sport'],
    denominations: {
      menuGestion: 'USAP FORMATION',
      menuFormation: 'Pédagogie',
      antenneField: 'Antenne',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Organisme de formation',
      antenneOrDispositif: 'Dispositif'
    },
    menu: {
      // Péda = Formation
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'EnqueteDebutFormation',
        'EnqueteMilieuFormation',
        'EnqueteFinFormation',
        'EnqueteFormateur',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: ['all_taxes'],
      candidature: ['demandeInscriptions']
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: false,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: [
        'cfa',
        'serveur',
        'ecole_privee_usap',
        'espace_perso',
        'pdp'
      ],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true,
      annuaireEntrepriseGlobal: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'cni',
        'carte_vitale',
        'cv',
        'certificat_medical',
        'attestation_400m',
        'attestation_rugby',
        'bnssa',
        'psc1',
        'pse1',
        'pse2',
        'autorisation_reproduction',
        'documents_diplomes',
        'dossier_inscription',
        'paiement_cvec',
        'paiement_cvec_2eme',
        'releve_notes',
        'journee_appel_bts',
        'attestation_assurance_scolaire_bts',
        'attestation_epmsp',
        'bti_entretiens',
        'evaluations_formatives',
        'positionnement',
        'fiche_mission',
        'grille_certification',
        'visites_structure'
      ],
      typeDocumentAdministratifsLabels: {
        ...typeDocumentAdministratifsLabels,
        cni: 'Carte identité/Carte de séjour',
        carte_sejour: 'Carte identité/Carte de séjour',
        attestation_400m: 'Attestation du 400m nage',
        dossier_inscription: 'Dossier d\'inscription – BTS',
        paiement_cvec: 'Paiement CVEC - BTS',
        releve_notes: 'Bulletin de note - BTS'
      },
      typeDocumentPedagogiques: [
        'non_renseigne',
        'attestation_epmsp',
        'bti_entretiens',
        'evaluations_formatives',
        'positionnement',
        'fiche_mission',
        'grille_certification',
        'test_exigences',
        'visites_structure',
        'bulletin_1er_semestre_1_annee',
        'bulletin_2eme_semestre_1_annee',
        'bulletin_1er_semestre_2_annee',
        'bulletin_2eme_semestre_2_annee',
        'bulletin_5eme_semestre',
        'bulletin_6eme_semestre',
        'bulletin_mi_semestre_1',
        'bulletin_mi_semestre_2',
        'bulletin_mi_semestre_3',
        'bulletin_mi_semestre_4',
      ],
      typeDocumentPedagogiquesLabels: {
        non_renseigne: 'Autre document'
      }
    },
    entretien: {
      interviewsType: ['suivi_formation', 'suivi_structure', 'entretien_confidentiel', 'autre']
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.acquis
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  demo: { // anciennement appelé aisp74
    id: 8,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 31
    },
    testOnly: true,
    activities: ['multi'],
    denominations: {
      menuGestion: 'DEMO',
      menuFormation: 'Pédagogie',
      antenneField: 'Dispositif de formation',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Dispositifs de formation',
      antenneOrDispositif: 'Dispositif'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'suivis',
        'enquetesatisfaction',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: [],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: true,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['siège', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_cpam',
        'attestation_entree_formation',
        'attestation_fin_formation',
        'attestation_inscription_formation',
        'attestation_prise_connaissance',
        'attestation_rqth',
        'autorisation_travail',
        'avis_situation_ft',
        'bulletins_salaire',
        'carte_sejour',
        'cni',
        'consentement_rgpd',
        'contrat_formation',
        'convention_pret_chromebook',
        'convention_stage',
        'droit_image',
        'fiche_prescription',
        'notification_rejet_are_france_travail_moins_3_mois',
        'reglement_interieur',
        'rib',
        'rs1_cerfa_remu'
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'non_renseigne',
        'auto_evaluation_des_besoins',
        'suivi_des_actions_pedagogiques',
        'synthese_suivis_actions_pedagogiques',
        'reunion_service',
        'reunion_pedagogique',
        'revue_effectif',
        'contrat_sejour_cegi',
        'reglement_fonctionnement_cegi'
      ]
    },
    entretien: {
      interviewsType: [
        'accompagnement_sante_social',
        'bilan_intermediaire',
        'contractualisation_engagement',
        'entretien_accueil',
        'entretien_ecoute',
        'entretien_bilan_fin_parcours',
        'entretien_referent_handicap',
        'entretien_regulation',
        'entretien_restitution_positionnement',
        'entretien_suivi_pedagogique',
        'entretien_suivi_projet_professionnel',
        'positionnement',
        'signalement',
        'entretien_confidentiel'
      ]
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.acquis
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  reseau_app: {
    id: 9,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 32
    },
    testOnly: true,
    activities: ['multi'],
    denominations: {
      menuGestion: 'RESEAU APP',
      menuFormation: 'Pédagogie',
      antenneField: 'Antenne',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Antenne',
      antenneOrDispositif: 'Antenne'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'suivis',
        'enquetesatisfaction',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: [],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: true,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['siège', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_cpam',
        'attestation_entree_formation',
        'attestation_fin_formation',
        'attestation_inscription_formation',
        'attestation_prise_connaissance',
        'attestation_rqth',
        'autorisation_travail',
        'avis_situation_ft',
        'bulletins_salaire',
        'carte_sejour',
        'cni',
        'consentement_rgpd',
        'contrat_formation',
        'convention_pret_chromebook',
        'convention_stage',
        'droit_image',
        'fiche_prescription',
        'notification_rejet_are_france_travail_moins_3_mois',
        'reglement_interieur',
        'rib',
        'rs1_cerfa_remu'
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'non_renseigne',
        'attestation_epmsp',
        'bilan_fin_parcours',
        'bti_entretiens',
        'contrat_pedagogique',
        'evaluations_formatives',
        'positionnement',
        'fiche_mission',
        'grille_certification',
        'livret_suivi_individuel_parcours',
        'test_exigences',
        'visites_structure'
      ]
    },
    entretien: {
      interviewsType: [
        'accompagnement_sante_social',
        'bilan_intermediaire',
        'contractualisation_engagement',
        'entretien_accueil',
        'entretien_ecoute',
        'entretien_bilan_fin_parcours',
        'entretien_referent_handicap',
        'entretien_regulation',
        'entretien_restitution_positionnement',
        'entretien_suivi_pedagogique',
        'entretien_suivi_projet_professionnel',
        'positionnement',
        'signalement',
        'entretien_confidentiel'
      ]
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.acquis
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  acerep: {
    id: 10,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 33
    },
    testOnly: true,
    activities: ['multi'],
    denominations: {
      menuGestion: 'ACEREP R2D',
      menuFormation: 'Pédagogie',
      antenneField: 'Antenne',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Antenne',
      antenneOrDispositif: 'Antenne'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'suivis',
        'enquetesatisfaction',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: [],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: true,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['siège', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_cpam',
        'attestation_entree_formation',
        'attestation_fin_formation',
        'attestation_inscription_formation',
        'attestation_prise_connaissance',
        'attestation_rqth',
        'autorisation_travail',
        'avis_situation_ft',
        'bulletins_salaire',
        'carte_sejour',
        'cni',
        'consentement_rgpd',
        'contrat_formation',
        'convention_pret_chromebook',
        'convention_stage',
        'droit_image',
        'fiche_prescription',
        'notification_rejet_are_france_travail_moins_3_mois',
        'reglement_interieur',
        'rib',
        'rs1_cerfa_remu'
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'non_renseigne',
        'attestation_epmsp',
        'bilan_fin_parcours',
        'bti_entretiens',
        'contrat_pedagogique',
        'evaluations_formatives',
        'positionnement',
        'fiche_mission',
        'grille_certification',
        'livret_suivi_individuel_parcours',
        'test_exigences',
        'visites_structure'
      ]
    },
    entretien: {
      interviewsType: [
        'accompagnement_sante_social',
        'bilan_intermediaire',
        'contractualisation_engagement',
        'entretien_accueil',
        'entretien_ecoute',
        'entretien_bilan_fin_parcours',
        'entretien_referent_handicap',
        'entretien_regulation',
        'entretien_restitution_positionnement',
        'entretien_suivi_pedagogique',
        'entretien_suivi_projet_professionnel',
        'positionnement',
        'signalement',
        'entretien_confidentiel'
      ]
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.acquis
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  lrf: {
    id: 11,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 100010
    },
    testOnly: true,
    activities: ['multi'],
    denominations: {
      menuGestion: 'LRF',
      menuFormation: 'Pédagogie',
      antenneField: 'Dispositif de formation',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Dispositif de formation',
      antenneOrDispositif: 'Dispositif'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'suivis',
        'enquetesatisfaction',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: ['all_taxes'],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: true,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['siège', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_assurance_maladie_datee_de_moins_de_3_mois',
        'attestation_employeur',
        'avis_situation_france_travail_moins_3_mois',
        'bulletins_salaire_sur_24_mois',
        'cni',
        'copie_du_livret_de_famille',
        'dernier_avis_imposition_pour_les_personnes_ayant_des_enfants_a_charge',
        'droit_image',
        'justificatifs_d_indemnites_journalieres_en_cas_d_arret_de_travail',
        'justificatif_rsa_pour_les_personnes_beneficiaires',
        'notification_rqth_en_cours_de_validite',
        'passeport',
        'rib',
        'titre_sejour_en_cours_de_validite',
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'non_renseigne',
      ]
    },
    entretien: {
      interviewsType: [
        'suivi_formation',
        'suivi_structure',
        'entretien_confidentiel',
        'autre'
      ]
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.acquis
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  greta_nord_alsace: {
    id: 12,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 100013
    },
    testOnly: true,
    activities: ['multi'],
    denominations: {
      menuGestion: 'GRETA NORD ALSACE',
      menuFormation: 'Pédagogie',
      antenneField: 'Dispositif de formation',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Dispositif de formation',
      antenneOrDispositif: 'Dispositif'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'suivis',
        'enquetesatisfaction',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: ['all_taxes'],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: true,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['siège', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true,
      annuaireEntrepriseGlobal: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_assurance_maladie_datee_de_moins_de_3_mois',
        'attestation_employeur',
        'avis_situation_france_travail_moins_3_mois',
        'bulletins_salaire_sur_24_mois',
        'cni',
        'copie_du_livret_de_famille',
        'dernier_avis_imposition_pour_les_personnes_ayant_des_enfants_a_charge',
        'droit_image',
        'justificatifs_d_indemnites_journalieres_en_cas_d_arret_de_travail',
        'justificatif_rsa_pour_les_personnes_beneficiaires',
        'notification_rqth_en_cours_de_validite',
        'passeport',
        'rib',
        'titre_sejour_en_cours_de_validite',
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'non_renseigne',
      ]
    },
    entretien: {
      interviewsType: [
        'suivi_formation',
        'suivi_structure',
        'entretien_confidentiel',
        'autre'
      ]
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.acquis
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  forcjecnor_2000: {
    id: 13,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 100012
    },
    testOnly: true,
    activities: ['multi'],
    denominations: {
      menuGestion: 'FORCJECNOR 2000',
      menuFormation: 'Pédagogie',
      antenneField: 'Dispositif de formation',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Dispositif de formation',
      antenneOrDispositif: 'Dispositif'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'suivis',
        'enquetesatisfaction',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: ['all_taxes'],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: true,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['siège', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true,
      annuaireEntrepriseGlobal: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_assurance_maladie_datee_de_moins_de_3_mois',
        'attestation_employeur',
        'avis_situation_france_travail_moins_3_mois',
        'bulletins_salaire_sur_24_mois',
        'cni',
        'copie_du_livret_de_famille',
        'dernier_avis_imposition_pour_les_personnes_ayant_des_enfants_a_charge',
        'droit_image',
        'justificatifs_d_indemnites_journalieres_en_cas_d_arret_de_travail',
        'justificatif_rsa_pour_les_personnes_beneficiaires',
        'notification_rqth_en_cours_de_validite',
        'passeport',
        'rib',
        'titre_sejour_en_cours_de_validite',
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'non_renseigne',
      ]
    },
    entretien: {
      interviewsType: [
        'suivi_formation',
        'suivi_structure',
        'entretien_confidentiel',
        'autre',
        'accompagnement_sante_social',
        'contractualisation_engagement',
        'entretien_accueil',
        'entretien_referent_handicap',
        'entretien_regulation',
        'entretien_suivi_pedagogique',
        'entretien_suivi_projet_professionnel',
        'securisation_parcours',
        'entretien_remediation',
        'administratif',
        'suivi_mobilite',
        'suivi_vues',
        'suivi_vae',
        'suivi_cep'
      ]
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.acquis
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
  app_alsace: {
    id: 14,
    userLogged: ['cfa', 'antenne'],
    cfa: {
      id: 100011
    },
    testOnly: true,
    activities: ['multi'],
    denominations: {
      menuGestion: 'APP ALSACE',
      menuFormation: 'Pédagogie',
      antenneField: 'Dispositif de formation',
      codeAnalytiqueField: 'Code analytique',
      antennelModuleName: 'Dispositif de formation',
      antenneOrDispositif: 'Dispositif'
    },
    menu: {
      formation: [
        'francecompetences',
        'referentiels',
        'actions',
        'sequences',
        'pif',
        'evaluations',
        'evaluations_cps',
        'tests'
      ],
      facturation: ['aidesmobilises', 'factures'],
      postformation: [
        'suivis',
        'enquetesatisfaction',
        'questionnaireinsertion'
      ],
      gestion: [
        'parametres',
        'referentiels',
        'tableaudebord',
        'antenne',
        'statistiques',
        'gedcollaborative',
        'modeles',
        'gestionutilisateurs'
      ],
      taxes: ['all_taxes'],
      candidature: []
    },
    accessRight: {
      hasSectors: true,
      hasAdministrativeBranch: false,
      hasSessions: true,
      hasGroups: true,
      typeDiplome: true,
      hasActionsRatingStars: true,
      hasRepositoriesRatingStars: false,
      canChangeAntenneInSwitchStudent: false,
      gedFolders: ['siège', 'antenne', 'espace_perso', 'pdp'],
      canSeeConventionNumberOnFacturation: true,
      hasSigVille: true,
      annuaireEntrepriseGlobal: true
    },
    conventions: {
      haveFeeTypeShortList: true
    },
    facturation: {
      typeFactureDetails: [
        'pack_informatique',
        'pack_materiel',
        'pack_informatique_1er_acompte',
        'pack_informatique_2eme_acompte',
        'pack_informatique_3eme_acompte',
        'pack_informatique_4eme_acompte',
        'pack_informatique_5eme_acompte',
        'pack_informatique_6eme_acompte'
      ]
    },
    stagiaire: {
      filtres: ['antennes'],
      typeDocumentAdministratifs: [
        'attestation_assurance_maladie_datee_de_moins_de_3_mois',
        'attestation_employeur',
        'avis_situation_france_travail_moins_3_mois',
        'bulletins_salaire_sur_24_mois',
        'cni',
        'copie_du_livret_de_famille',
        'dernier_avis_imposition_pour_les_personnes_ayant_des_enfants_a_charge',
        'droit_image',
        'justificatifs_d_indemnites_journalieres_en_cas_d_arret_de_travail',
        'justificatif_rsa_pour_les_personnes_beneficiaires',
        'notification_rqth_en_cours_de_validite',
        'passeport',
        'rib',
        'titre_sejour_en_cours_de_validite',
      ],
      typeDocumentAdministratifsLabels,
      typeDocumentPedagogiques: [
        'non_renseigne',
      ]
    },
    entretien: {
      interviewsType: [
        'suivi_formation',
        'suivi_structure',
        'entretien_confidentiel',
        'autre'
      ]
    },
    pedagogie: {
      filtres: ['antennes'],
      evaluationScale: evaluationScales.acquis
    },
    // champ json en bdd
    orderFieldsTrainingForm: {
      type_cursus: 'order-3',
      status: 'order-4',
      type_status_autre_details: 'order-5',
      antenne: 'order-0',
      antenne_secteur: 'order-2',
      antenne_convention: 'order-2',
      type_action: 'order-6',
      diplome: 'order-6',
      module: 'order-6',
      diplome_session: 'order-7',
      action_session: 'order-7',
      antenne_groupe_session: 'order-7',
      dt_date_entree: 'order-8',
      date_entree_prevue: 'order-8',
      date_sortie_prevue: 'order-9',
      date_selection_trials: 'order-10',
      date_selection_requirement: 'order-11',
      date_positioning_start: 'order-12',
      date_positioning_end: 'order-12',
      dt_date_first_contact: 'order-100',
      funding: 'order-101',
      funding_details: 'order-102',
      formation_hours: 'order-103',
      company_hours: 'order-104',
      entreprise_tuteur_title: 'order-200',
      desired_entreprise: '201',
      desired_tutor: 'order-202',
      desired_tutor_lastname: 'order-203',
      desired_tutor_firstname: 'order-204',
      btn_choose_another_tuteur: 'order-205',
      pole_emploi_title: 'order-300',
      pole_emploie_id: 'order-301',
      pole_emploie_since: 'order-302',
      pole_emploie_agency: 'order-303',
      pole_emploie_advisor: 'order-304',
      pole_emploie_advisor_phone: 'order-305',
      formationCustomFields: 'order-306'
    }
  },
}

export const parametrageCfas = {
  namespaced: false,
  state: {
    paramCfas: []
  },
  mutations: {
    setParamCfas(state, paramCfas) {
      state.paramCfas = Object.values(paramCfas)
    }
  },
  actions: {
    fetchParamCfas(context) {
      return context.commit('setParamCfas', paramCfas)
    }
  },
  getters: {
    getParamCfas(state) {
      return state.paramCfas
    },
    getCfaParams: (state) => (userCfaId, userCheckStatus) => {
      if (userCheckStatus) {
        return state.paramCfas.find((cfaParams) => {
          return (
            cfaParams.cfa.id === userCfaId &&
            cfaParams.userLogged.includes('cfa')
          )
        })
      } else {
        return state.paramCfas.find((cfaParams) => {
          return (
            cfaParams.cfa.id === userCfaId &&
            cfaParams.userLogged.includes('antenne')
          )
        })
      }
    }
  }
}
